module.exports = __webpack_public_path__ + "static/media/47.0d8b8029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/47.jpg
// module id = 416
// module chunks = 0